<template>
  <div id="event-handling" class="demo">
    <input v-model="message" placeholder="edit me" />
    <button v-on:click="rotateMessage">Rotate Message</button>
    <hr />
    <button v-on:click="restoreMessage">Restore Message</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: "Hello Vue.js!",
    };
  },
  methods: {
    rotateMessage() {
      this.message = this.rotateString(this.message);
    },
    restoreMessage() {
      this.message = this.restore(this.message);
    },
    rotateString(message) {
      let normal = "abcdefghijklmnopqrstuvwxyz_,;.?!/\\'";
      let mirror = "ɐqɔpǝɟbɥıظʞןɯuodbɹsʇnʌʍxʎz‾'؛˙¿¡/\\,";

      normal += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      mirror += "∀qϽᗡƎℲƃHIſʞ˥WNOԀὉᴚS⊥∩ΛMXʎZ";

      normal += "0123456789";
      mirror += "0ƖᄅƐㄣϛ9ㄥ86";

      return message
        .split("")
        .reverse()
        .reduce((pre, cur) => {
          let index = normal.indexOf(cur);
          if (index === -1) {
            return pre;
          } else {
            return (pre += mirror[index]);
          }
        }, "");
    },
    restore(rotatedString) {
      let normal = "abcdefghijklmnopqrstuvwxyz_,;.?!/\\'";
      let mirror = "ɐqɔpǝɟbɥıظʞןɯuodbɹsʇnʌʍxʎz‾'؛˙¿¡/\\,";

      normal += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      mirror += "∀qϽᗡƎℲƃHIſʞ˥WNOԀὉᴚS⊥∩ΛMXʎZ";

      normal += "0123456789";
      mirror += "0ƖᄅƐㄣϛ9ㄥ86";

      return rotatedString
        .split("")
        .reverse()
        .reduce((pre, cur) => {
          let index = mirror.indexOf(cur);
          if (index === -1) {
            return pre;
          } else {
            return (pre += normal[index]);
          }
        }, "");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.demo {
  font-family: sans-serif;
  border: 1px solid #eee;
  border-radius: 2px;
  padding: 20px 30px;
  margin-top: 3em;
  margin-bottom: 120px;
  user-select: none;
  overflow-x: auto;
}
</style>
